import React from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import GlobalStyles from './globalStyles'

import { theme } from './index'

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => (
  <StyledThemeProvider theme={theme}>
    <GlobalStyles mode="light" />
    {children}
  </StyledThemeProvider>
)
